import H from '@components/heading'
import Container from '@components/container'
import A from '@components/anchor'

interface ErrorFallbackProps {
  error?: Error
}

export default function ErrorFallback(props: ErrorFallbackProps) {
  return (
    <Container className="grid grid-cols-12">
      <div className="col-span-12 lg:col-span-10 lg:col-start-2 flex flex-col justify-center my-10 md:my-15 gap-y-5">
        <H level={1} size="h2">
          Page not available
        </H>
        <p>
          We&apos;re sorry. An error has occurred on the page you were attempting to view. The
          following information has been reported and we will address this as soon as possible.
        </p>
        <p>
          If you need assistance, call us at &nbsp;<A href="tel:+18008274277">1-800-82-SHARP</A>
          &nbsp;(<A href="tel:+18008274277">1-800-827-4277</A>), &nbsp;Monday through Friday, 7 am
          to 7 pm. If you&apos;re experiencing a medical or psychiatric emergency, call 911
          immediately or go to the nearest emergency room.
        </p>
      </div>
    </Container>
  )
}
